import { render, staticRenderFns } from "./SessionEndResume.vue?vue&type=template&id=bffb4de8&scoped=true&"
import script from "./SessionEndResume.vue?vue&type=script&lang=js&"
export * from "./SessionEndResume.vue?vue&type=script&lang=js&"
import style0 from "./SessionEndResume.vue?vue&type=style&index=0&id=bffb4de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb4de8",
  null
  
)

export default component.exports